/*
  Первая загрузка сайта в «Основе» (R42, spec-2 §3.1): кнопка «Первая загрузка» на верхней полосе проигрывает
  сцену загрузки поверх оболочки. Шаги образца — по 600 мс; при темпе «Быстро» тоже, иначе сцену не увидеть: она
  уложилась бы в 400 мс и не показалась. «Сбой» — загрузка встаёт на шаге 3, «Повторить» проходит; без связи шаги
  стоят, пока она не вернётся. Настоящие шаги (сессия, права, меню, код модуля) — зона ядра (spec-2 §11).
*/

export const BOOT_STEPS = [
  'Kaname',
  'Вход',
  'Профиль и права',
  'Сервисы и меню',
  'Вкладки',
  'Первый экран',
] as const;

/** Сколько идёт шаг образца. Первый («Kaname») к появлению сцены уже пройден. */
export const BOOT_STEP_MS = 600;

/** Шаг, на котором встаёт «Сбой»: третий, «Профиль и права». */
export const BOOT_FAIL_STEP = 2;

/** Почему встала загрузка в темпе «Сбой». */
export const BOOT_FAILURE = { reason: 'Сервер не ответил за 10 с' };
